import { ReactNode } from 'react';

import {
  MultipleChoiceListCorrect,
  MultipleChoiceListIncorrect,
} from '../multiple-choice';
import * as Styled from './multiple-choice-radio.style';

type Props = JSX.IntrinsicElements['input'] & {
  label: ReactNode;
  disabled?: boolean;
  isCorrect?: boolean;
  isIncorrect?: boolean;
  isSelected?: boolean;
};

const MultipleChoiceRadioSelectedAnswer = ({
  label,
  disabled,
  isCorrect,
  isIncorrect,
  isSelected,
  ...inputProps
}: Props) => {
  return (
    <Styled.MultipleChoiceRadioInputLabel
      $disabled={disabled}
      htmlFor={inputProps.id}
      as="div"
    >
      <Styled.MultipleChoiceRadioInputFieldWrapper>
        {isCorrect ? (
          <MultipleChoiceListCorrect />
        ) : isIncorrect ? (
          <MultipleChoiceListIncorrect />
        ) : (
          <Styled.MultipleChoiceRadioInputDecor $isSelected={isSelected}>
            <div />
          </Styled.MultipleChoiceRadioInputDecor>
        )}
      </Styled.MultipleChoiceRadioInputFieldWrapper>
      <Styled.MultipleChoiceRadioInputTextWrapper data-selector="radio-input-label">
        {label}
      </Styled.MultipleChoiceRadioInputTextWrapper>
    </Styled.MultipleChoiceRadioInputLabel>
  );
};

export default MultipleChoiceRadioSelectedAnswer;
